import React, { useState } from "react";
import "./Statistics.css";
import { useSelector } from "react-redux";
import { useBetween } from "use-between";
import { getTranslatedText as translate } from "../../Localization/Translation";
import ShowMore from "react-show-more-button";
import BarChart from "./BarChar/barChar.js";
import Footer from "../../Footer/Footer.js";

const Statistics = () => {
  const { landury, delegate, moreLanduryUse, locale } = useBetween(
    useSelector((state) => state.useSharedLang)
  );
  const state = useSelector((state) => state);

  const [openTap, setOpenTap] = useState(0);
  const [handleSeeMore, setHandelSeeMore] = useState(true);
  const [handleTextSeeMore, sethandleTextSeeMore] = useState("عرض المزيد");
  const [handleSeeMore1, setHandelSeeMore1] = useState(true);
  const [handleTextSeeMore1, sethandleTextSeeMore1] = useState("عرض المزيد");
  const changeBtnSeeMore = () => {
    if (handleSeeMore === true) {
      sethandleTextSeeMore("عرض الأقل");
      setHandelSeeMore(false);
    } else {
      sethandleTextSeeMore("عرض المزيد");
      setHandelSeeMore(true);
    }
  };
  const changeBtnSeeMore1 = () => {
    if (handleSeeMore1 === true) {
      sethandleTextSeeMore1("عرض الأقل");
      setHandelSeeMore1(false);
    } else {
      sethandleTextSeeMore1("عرض المزيد");
      setHandelSeeMore1(true);
    }
  };
  const Delegate = delegate.map((item, i) => {
    return (
      <tr className="firstRow" key={i}>
        <td>{item.orderState}</td>
        <td>{item.orderCount}</td>
      </tr>
    );
  });

  const Landury = landury.map((item, i) => {
    return (
      <tr className="firstRow" key={i}>
        <td>{item.orderState}</td>
        <td>{item.orderCount}</td>
      </tr>
    );
  });
  let d = "-1";
  const MoreLanduryUse = moreLanduryUse.map((item, i) => {
    d = Number(d) + 1;
    return (
      <div
        className={
          "statiMoreLandu animate__animated animate__fadeInLeft animate__delay-" +
          d +
          "s"
        }
      >
        <div className="NumOfLandu">{i + 1}</div>
        <div className="landINFO">
          <div className="firstRow">
            <div className="LanduName">{item.LanName}</div>
            <div className="LanduRate">
              {" "}
              <i className="fa fa-star" aria-hidden="true"></i> {item.rate}/5
            </div>
          </div>
          <div className="secondRow">
            <div className="Accepted">
              <span></span> {translate("number-of-accepted-orders", locale)}
              {item.orderCountAccepted[0].Num}
            </div>
            <div className="Complete">
              <span></span> {translate("number-of-done-orders", locale)}
              {item.orderCountComplete[0].Num}
            </div>
            <div className="Delete">
              <span></span> {translate("number-of-rejected-orders", locale)}
              {item.orderCountDelete[0].Num}
            </div>
          </div>
        </div>
        <div className="lineBar">
          <div
            className="firstLine"
            role="progressbar"
            style={{ width: "80%" }}
            aria-valuenow={80}
            aria-valuemin="0"
            aria-valuemax="100"
          >
            80%
          </div>
          <div
            className="theardLine"
            role="progressbar"
            style={{ width: "20%" }}
            aria-valuenow={70}
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
          <div
            className="secondLine "
            role="progressbar"
            style={{ width: "20%" }}
            aria-valuenow={20}
            aria-valuemin="0"
            aria-valuemax="100"
          >
            20%
          </div>
        </div>
      </div>
    );
  });
  const currentTap = (num, newClassName) => {
    setOpenTap(num);
    var newTab = document.querySelector(newClassName);

    Array.from(document.querySelectorAll(".main-tab")).forEach(function (val) {
      val.style.fontWeight = "normal";
    });
    newTab.style.fontWeight = "bold";
  };

  return (
    <div className="main-component Statistics">
      {/* <div
        className="Statistics"
        style={{
          direction: Lang === "Arabic" || Lang === "pakistani" ? "rtl" : "ltr",
        }}
      > */}
      <div className="main-navbar" dir="auto">
        <span
          to="/Navbar/JoinRequests/delivery"
          className="daily-requests-tab main-tab current-main-tab nav-link-main-navbar"
          onClick={() => currentTap(0, ".daily-requests-tab")}
        >
          <span>{translate("daily-done-orders-tab", locale)}</span>
        </span>
        <span
          to="/Navbar/JoinRequests/Laundry"
          className="payed-money-tab main-tab nav-link-main-navbar"
          onClick={() => currentTap(1, ".payed-money-tab")}
        >
          <span>{translate("payed-money-tab", locale)}</span>
        </span>
        <span
          to="/Navbar/JoinRequests/Laundry"
          className="most-used-laundry-tab main-tab nav-link-main-navbar"
          onClick={() => currentTap(2, ".most-used-laundry-tab")}
        >
          <span>{translate("most-used-laundry", locale)}</span>
        </span>
      </div>
      <div className="statistics-tab">
        {openTap === 0 && (
          <div className="dailyStats">
            {/* Filter By City */}
            <div className="filter-by-city-statistics">
              <select className="selectFilter" name="filter">
                <option className="optionsMenu" value="rate">
                  {translate("choose-city", locale)}
                </option>
                <option className="optionsMenu" value="near">
                  {translate("choose-city", locale)}
                </option>
              </select>
            </div>

            <div className="delegate">
              <p className="title">{translate("Deliverymen-header", locale)}</p>
              <ShowMore
                maxHeight={300}
                onChange={() => changeBtnSeeMore()}
                button={<div className="BtnSeeMore">{handleTextSeeMore}</div>}
              >
                <table
                  id="exampl"
                  className="table cell-border animate__animated animate__fadeInLeft"
                >
                  <thead className="TableHead">
                    <tr>
                      <th style={{ width: "70%" }}>
                        {translate("delivery-person-name", locale)}
                      </th>
                      <th style={{ width: "30%" }}>
                        {translate("Number-of-completed-orders", locale)}
                      </th>
                    </tr>
                  </thead>
                  <tbody>{Delegate}</tbody>
                </table>
              </ShowMore>
            </div>
            <div className="landury">
              <p className="title">{translate("Laundromats-header", locale)}</p>
              <ShowMore
                maxHeight={300}
                onChange={() => changeBtnSeeMore1()}
                button={<div className="BtnSeeMore">{handleTextSeeMore1}</div>}
              >
                <table
                  id="exampl"
                  className="table cell-border animate__animated animate__fadeInLeft animate__delay-3s"
                >
                  <thead className="TableHead">
                    <tr>
                      <th style={{ width: "70%" }}>
                        {translate("laundry-name", locale)}
                      </th>
                      <th style={{ width: "30%" }}>
                        {translate("Number-of-completed-orders", locale)}
                      </th>
                    </tr>
                  </thead>
                  <tbody>{Landury}</tbody>
                </table>
              </ShowMore>
            </div>
          </div>
        )}
        {openTap === 1 && (
          <div
            className="barChar1"
            style={{
              direction: locale === "AR" || locale === "OR" ? "rtl" : "ltr",
            }}
          >
            <div className="barChar-container">
              <BarChart
                selectYear={0}
                w={500}
                h={300}
                svgMt={"1%"}
                // svgMr={"40%"}
                paddongXscale={0.1}
                XAxisFontS={"0.8em"}
                colorText={"white"}
                textMt={66}
                textFontS={"6.5px"}
                display={false}
                text="barChar1"
              />
            </div>
          </div>
        )}
        {openTap === 2 && (
          <div className="moreUse">
            {/* Filter By City */}
            <div className="filter-by-city-statistics">
              <select className="selectFilter" name="filter">
                <option className="optionsMenu" value="rate">
                  {translate("choose-city", locale)}
                </option>
                <option className="optionsMenu" value="near">
                  {translate("choose-city", locale)}
                </option>
              </select>
            </div>
            <div className="moreUse-div">
              <p className="textMoreUse">
                <i className="fa fa-sort-amount-desc" aria-hidden="true"></i>
                {translate("sort-label-statistics", locale)}
              </p>
              {MoreLanduryUse}
            </div>
          </div>
        )}
      </div>
      <Footer />
      {/* </div> */}
    </div>
  );
};

export default Statistics;
